import React from 'react'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import { Item } from '../../../../common/snippets'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { bookingSummaryColumn, franchiseeExcelHeader1, pdfFranchiseeHeaderColumn } from '../BookingConstants'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { colors, focusElemnt, navigation3 } from '../../../../common/helper'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import { RenderTable } from '../../analysisReport/summmaryTable'
import { RenderTableExcel } from '../../analysisReport/summaryTableExcel'
import { makeTable } from '../../analysisReport/pdfAutotable'
var totalPagesExp = '{total_pages_count_string}'
const FranchiseeBookingSummary = ({
  checkCrossinglr,
  loginData,
  tableData,
  fromDate,
  toDate,
  sourceCity,
  sourceBranch,
  sourceBranchUser,
  franchiseeCompany,
  destinationBranch,
  paymentType,
  transactionType,
  selReportView,
  status,
  headers,
  disableExcel,
  UseToPayAsCOD
}) => {
  const companySettings = useSelector((state) => state?.common?.companySettings[0])
  const loginCountryId = companySettings?.DefaultCurrencyID;
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
      str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(
      `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
      2 +
      90,
      pageHeight - 5
    )
  }
  function pdfLogoDraw(data,doc) {
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Report View: Summary`, 30, 170)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Inclusive Crossing LRs: ${checkCrossinglr ? 'Yes' : 'No'}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Booking Date : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 145)
    doc.setFontSize(18)
    doc.setFont('Roboto', 'bold')
    doc.text(`Report: Franchisee Bookings`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
    doc.setTextColor(40)
    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
    doc.setFontSize(26).setFont('Roboto', 'bold')
    doc.setTextColor(16, 79, 162)
    doc.text('Cargo System | Franchisee Booking Reports', 30 + 60, 80)
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(22).setFont('Roboto', 'bold')
    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    jsPdfHeaderFooter(data, loginData, totalPagesExp)
  }
  const generatepdf = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = pdfFranchiseeHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = headers.map(col => ({header: col.exportHead,dataKey: col.field,xlCol: col.xlCol}));
    const HeaderData = [
      {
        sourceCity: sourceCity?.SourceCityName,
        sourceBranch: sourceBranch?.SourceBranchName,
        sourceBranchUser: sourceBranchUser?.UserBooked,
        destCity: franchiseeCompany?.DeliveryCompany,
        destBranch: destinationBranch?.DestBranchName,
        paymentType: paymentType?.name,
        trnsType: transactionType?.TransType,
        reportView: selReportView?.ReportView,
        status: status?.LrStatus,
        dataType: 'entry'
      },
    ]
    const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px' })

    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, HeaderColumns, HeaderData, 1, '', loginData, "everyPage", () => { }, 200,false)
    makeTable(doc, autoTable, pdfColumns, tableData, 1, '', loginData, "never", pdfLogoDraw)
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Franchisee ${'Booking'} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('FranchiseeBooingDetailed').data = doc.output('datauristring', 'Booking Report')
        focusElemnt('backBtn')
      }, 2000)
    } setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      document.getElementById('FranchiseeBooingDetailed').data = doc.output('datauristring', 'Item List.pdf')
      focusElemnt('backBtn')
    }, 2000)

  }
  return (
    <>
      <Stack style={{ margin: '0px 10px' }}>
        <Item className="userReport" style={{ paddingRight: '0px', paddingBottom: '0px' }}>
          <Item className="userReport-heading">Report For: Franchisee Booking Report</Item>
          <Item className="userReport-buttons">
            {showTable ? (
              <>
                {disableExcel ? (
                  <Box>
                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                      Export to Excel
                    </Button>
                  </Box>
                ) : (
                  <Box onKeyDown={(e) => navigation3(e, 'exportAsPdfBtn', 'franchiseeSplitBtn', () => { })}>
                    <ReactHtmlTableToExcel
                      id="ExpToExlbtn"
                      className="userWisereporttemExcelBtn"
                      table="table-to-xls"
                      filename={`Franchisee Booking Report ${currentDateTime}`}
                      sheet="tablexls"
                      buttonText="Export to Excel"
                    />
                  </Box>
                )}
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => generatepdf(true)}
                    onKeyDown={(e) => navigation3(e, 'PrintBtn', disableExcel ? 'franchiseeSplitBtn' : 'ExpToExlbtn', () => { generatepdf(true) })}
                    id="exportAsPdfBtn"
                    >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => generatepdf(false)}
                    id="PrintBtn"
                    onKeyDown={(e) => navigation3(e, 'fromDate', 'exportAsPdfBtn', () => { generatepdf(false) })}
                    >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button variant="outlined" className="userWisereporttembtn" onClick={() => setShowTable(true)}>
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 450, paddingTop: '10px' }}>
            <TableContainer className="scroll" style={{ border: 'none', boxShadow: 'none', borderRadius: '6px' }}>
              <RenderTable  showHeader={false} header={headers} data={tableData} datacolStyle={{whiteSpace:'pre'}}/>
              <Table style={{ display: 'none' }} id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={13}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={14}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={27}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {franchiseeExcelHeader1?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{sourceCity?.SourceCityName}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>
                      <span>{sourceBranch?.SourceBranchName}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={4}>
                      <span>{sourceBranchUser?.UserBooked}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>
                      <span>{franchiseeCompany?.DeliveryCompany}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>
                      <span>{destinationBranch?.DestBranchName}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{paymentType?.name}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{transactionType?.TransType}</span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{selReportView?.ReportView} </span>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }} colSpan={2}>
                      <span>{status?.LrStatus} </span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={headers.length}></TableCell>
                  </TableRow>
                </TableHead>
                <RenderTableExcel showHeader={false} header={headers} data={tableData}/>
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
              <object
                id="FranchiseeBooingDetailed"
                type="application/pdf"
                width="100%"
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              ></object>
            </Box>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default FranchiseeBookingSummary
